import { defineNuxtPlugin } from '#app';
import { useNuxtApp } from '#imports';
import { GoogleMap, CustomMarker, MarkerCluster } from 'vue3-google-map';

export default defineNuxtPlugin({
    hooks: {
        'app:created': () => {
            const { vueApp } = useNuxtApp();
            try {
                vueApp.component('GoogleMap', GoogleMap);
                vueApp.component('GoogleMapCustomMarker', CustomMarker);
                vueApp.component('GoogleMapMarkerCluster', MarkerCluster);
            } catch (e) {
                console.error(e);
            }
        },
    },
});
